import {css} from 'styled-components';

export const DisplacementTransition = ({props, startY=0, endY=0, time=1, delay=1, startX=0, endX=0}) => {
  if (typeof(props.showTransition) !== 'undefined' && !props.showTransition) {
    return css`
      transform: translate(${startX}, ${startY});
      opacity: ${props.exit ? 1 : 0};
    `
  }
  if (props.showTransition) {
    return css`
      transform: translate(${endX}, ${endY});
      opacity: ${props.exit ? 0 : 1};
      transition: transform ${time}s ${delay}s, opacity ${time}s ${delay}s;
    `
  }
}